var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlobs02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B1DBB4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,41c58.2,0,100.6,28.2,121,83.2c21.5,58,42,116.4,58.9,176c7.7,27.3,12.3,55.3,5.5,83.8 c-7.9,33.2-26.8,57.1-58.8,70.1c-25.4,10.3-47.3,3.8-66.7-14c-12.4-11.3-20.6-25.6-28.9-39.9c-5.3-9.2-10.8-18.3-16.3-27.3 c-18.7-30.6-46.7-41.1-81.4-38.1c-46.8,4.1-93,4.1-136.2-19.3c-60.9-33-65.2-119.2-7.1-156.6c13.3-8.6,27.8-15.4,42.1-22.4 c31-15.1,59.2-33.7,82.5-59.7C218.4,51.8,247.8,40.9,281.2,41z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobs02);
export default __webpack_public_path__ + "static/media/blobs-02.5b060153b6d0c3a84a0f35c554969e3d.svg";
export { ForwardRef as ReactComponent };